import { defineComponent as _defineComponent } from 'vue'
import { QuizCard } from '@/models';
import { i18n } from '@/assets/i18n';
import { store } from '@/store';


export default /*@__PURE__*/_defineComponent({
  __name: 'QuizCardModal',
  props: {
    card: { type: Object, required: true }
  },
  emits: ['onClose'],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

const emit = __emit;
const props = __props;

const __returned__ = { emit, props, get i18n() { return i18n }, get store() { return store } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})